import React, { useState, useEffect } from "react";
import axios from "axios";
import { set } from "mongoose";

const Home = () => {
  const [problems, setProblems] = useState([]);
  const [filteredProblems, setFilteredProblems] = useState([]);
  const [anotherFilter, setAnotherFilter] = useState([]);
  const [selectedRating, setSelectedRating] = useState("");
  const [statusCounts, setStatusCounts] = useState({});

  useEffect(() => {
    const fetchProblems = async () => {
      try {
        const storedRating = localStorage.getItem("selectedRating");
        if (storedRating) {
          setSelectedRating(storedRating);
        }
        const response = await axios.get(
          "https://cp-tracker-backend.onrender.com/problem/getAllProblems"
        );
        setProblems(response.data);
      } catch (error) {
        console.error("Error fetching problems:", error);
      }
    };

    fetchProblems();
  }, []);


  useEffect(() => {
    if (selectedRating) {
      const filtered = problems.filter(
        (problem) => problem.problemRating === selectedRating
      );
      const another = problems.filter(
        (problem) => problem.problemRating === selectedRating && (problem.problemStatus === "withoutTestCase" || problem.problemStatus === "withTestCase")
      )
      setAnotherFilter(another);
      setFilteredProblems(filtered);
    } else {
      setFilteredProblems(problems);
    }
  }, [selectedRating, problems]);

  useEffect(() => {
    const counts = {
      withoutTestCase: 0,
      withTestCase: 0,
      withEditorial: 0,
      withSolution: 0,
      disaster: 0,
    };

    filteredProblems.forEach((problem) => {
      counts[problem.problemStatus]++;
    });

    setStatusCounts(counts);
  }, [filteredProblems]);

  const handleButtonClick = (rating) => {
    setSelectedRating(rating);
    localStorage.setItem("selectedRating", rating);
  };

  const calculatePercentage = (count) => {
    const total = Object.values(statusCounts).reduce(
      (acc, curr) => acc + curr,
      0
    );
    return total === 0 ? 0 : ((count / total) * 100).toFixed(2);
  };

  return (
    <div>
      <main className="main">
        <section className="buttons">
          <button onClick={() => handleButtonClick("")}>All</button>
          <button onClick={() => handleButtonClick("1300")}>1300</button>
          <button onClick={() => handleButtonClick("1400")}>1400</button>
          <button onClick={() => handleButtonClick("1500")}>1500</button>
          <button onClick={() => handleButtonClick("1600")}>1600</button>
          <button onClick={() => handleButtonClick("1700")}>1700</button>
        </section>
        <section className="info">
          <h2>Problems</h2>
          <table>
            <thead>
              <tr>
                <th>Rating</th>
                <th>Link</th>
                <th>Time Needed</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredProblems.map((problem) => (
                <tr key={problem._id}>
                  <td>{problem.problemRating}</td>
                  <td>
                    <a href={problem.problemLink} target="_blank" rel="noreferrer"> {problem.problemName}</a>
                  </td>
                  <td>{problem.timeNeeded}</td>
                  {/* <td>{problem.problemStatus}</td> */}
                  <td
                    style={{
                      backgroundColor:
                        problem.problemStatus === "withoutTestCase"
                          ? "#41B06E"
                          : problem.problemStatus === "withTestCase"
                          ? "#8DECB4"
                          : problem.problemStatus === "withEditorial"
                          ? "#FFC470"
                          : problem.problemStatus === "withSolution"
                          ? "#DD5746"
                          : problem.problemStatus === "disaster"
                          ? "#803D3B"
                          : "transparent",
                      color: "white",
                    }}
                  >
                    {problem.problemStatus}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="additional-info">
            <p>Solved Problems: {anotherFilter.length}</p>
            <p>Total Tried: {filteredProblems.length}</p>
            <p>
              Success Rate:{" "}
              {((anotherFilter.length / filteredProblems.length) * 100).toFixed(
                2
              )}
              %{" "}
            </p>
            <p>
              Time Needed:{" "}
              {anotherFilter.reduce((acc, curr) => acc + curr.timeNeeded, 0)}{" "}
              Minutes
            </p>
            <p>
              Time Tried:{" "}
              {filteredProblems.reduce((acc, curr) => acc + curr.timeNeeded, 0)}{" "}
              Minutes
            </p>
            <p>
              Average Time to Succeed:{" "}
              {anotherFilter.length
                ? (
                    anotherFilter.reduce(
                      (acc, curr) => acc + curr.timeNeeded,
                      0
                    ) / anotherFilter.length
                  ).toFixed(2)
                : 0} {" "} Minutes
            </p>
            <p>
              Average Time Given Per Problem:{" "}
              {filteredProblems.length
                ? (
                    filteredProblems.reduce(
                      (acc, curr) => acc + curr.timeNeeded,
                      0
                    ) / filteredProblems.length
                  ).toFixed(2)
                : 0}
                {" "} Minutes
            </p>
            <p>
              Percentage of Statuses:
              <table>
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Number of Problems</th>
                    <th>Percentage</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(statusCounts).map(([status, count]) => (
                    <tr key={status}>
                      <td>{status}</td>
                      <td>{count}</td>
                      <td>{calculatePercentage(count)}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;
